(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patch-report-photo', {
            parent: 'entity',
            url: '/patch-report-photo?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReportPhoto.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report-photo/patch-report-photos.html',
                    controller: 'PatchReportPhotoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReportPhoto');
                    $translatePartialLoader.addPart('patchPhotoType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('patch-report-photo-detail', {
            parent: 'entity',
            url: '/patch-report-photo/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReportPhoto.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report-photo/patch-report-photo-detail.html',
                    controller: 'PatchReportPhotoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReportPhoto');
                    $translatePartialLoader.addPart('patchPhotoType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PatchReportPhoto', function($stateParams, PatchReportPhoto) {
                    return PatchReportPhoto.get({id : $stateParams.id});
                }]
            }
        })
        .state('patch-report-photo.new', {
            parent: 'patch-report-photo',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-photo/patch-report-photo-dialog.html',
                    controller: 'PatchReportPhotoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                patchPhotoName: null,
                                patchPhotoType: null,
                                patchPhoto: null,
                                patchPhotoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patch-report-photo', null, { reload: true });
                }, function() {
                    $state.go('patch-report-photo');
                });
            }]
        })
        .state('patch-report-photo.edit', {
            parent: 'patch-report-photo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-photo/patch-report-photo-dialog.html',
                    controller: 'PatchReportPhotoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatchReportPhoto', function(PatchReportPhoto) {
                            return PatchReportPhoto.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report-photo', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patch-report-photo.delete', {
            parent: 'patch-report-photo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-photo/patch-report-photo-delete-dialog.html',
                    controller: 'PatchReportPhotoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatchReportPhoto', function(PatchReportPhoto) {
                            return PatchReportPhoto.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report-photo', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
